import { render, staticRenderFns } from "./Adaptive.vue?vue&type=template&id=4d6c8104&scoped=true"
import script from "./Adaptive.vue?vue&type=script&lang=js"
export * from "./Adaptive.vue?vue&type=script&lang=js"
import style0 from "./Adaptive.vue?vue&type=style&index=0&id=4d6c8104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6c8104",
  null
  
)

export default component.exports